import { useState } from "react";
import { Form, Button, InputGroup, Row, Col, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import ApiUtil from "../../util/ApiUtil";
import ApiPath from "../../util/ApiPath";
import SessionUtil from "../../util/SessionUtil";
import PhoneInput from "../PhoneInput";

function FormLogin({ type, handleClick }) {
  const { t } = useTranslation(); // Use t instead of lang
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(null);
  const [phone, setPhone] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [msgError, setMsgError] = useState("");
  const [selectedAreaCode, setSelectedAreaCode] = useState("962");
  const [isValid, setIsValid] = useState(true);
  const isLoggedIn = SessionUtil.isLoggedIn();

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate();

  const validation = () => {
    setValidated(true);
    // setIsValid(true);

    if (password === "") {
      setPasswordError(false);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    validation();
    if (phone && password && isValid) {
      // API
      // Redirect or handle login success
      handleLogin();
    }
  };
  const handleLogin = async () => {
    let data = {
      AreaCode: selectedAreaCode,
      PhoneNumber: phone,
      Password: password,
      Role: type === "1" ? "OPERATION" : type === "2" ? "FINANCIAL" : "ADMIN",
      Provider: "web",
    };
    const res = await ApiUtil.postApi(ApiPath.LOGIN, data, "POST");
    if (res.IsSuccessfull) {
      if (rememberMe) {
        SessionUtil.setUser(res.Result.AppUsers);
      }
      SessionUtil.setToken(res.Result.token);
      SessionUtil.setTypeUser(type);
      SessionUtil.setUser(res.Result.AppUsers);
      if (isLoggedIn)
        navigate(type === "1" ? "/operation" : "/driver-list", {
          state: {
            type: type,
          },
        });
      window.location.reload();
    } else {
      setValidated(false);
      setMsgError(res.Errors[0].Message);
    }
  };
  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      {/* phone number */}
      <PhoneInput
        phone={phone}
        setPhone={setPhone}
        selectedAreaCode={selectedAreaCode}
        setSelectedAreaCode={setSelectedAreaCode}
        isValid={isValid}
        setIsValid={setIsValid}
      />

      {/* password */}
      <Form.Group className="mb-3" controlId="formGroupPassword">
        <Form.Label className="font-SemiBold">{t("Password")}*</Form.Label>
        <InputGroup>
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="**************"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (passwordError !== null)
                e.target.value !== ""
                  ? setPasswordError(true)
                  : setPasswordError(false);
            }}
            required
          />
          <div
            className={`btn-input-group ${
              passwordError === null
                ? ""
                : passwordError
                ? "border-success"
                : "border-danger"
            }`}
            onClick={togglePassword}
          >
            {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
          </div>
          <Form.Control.Feedback type="invalid">
            {t("Please enter password")}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
      <Row className="justify-content-between">
        <Col xs={6}>
          <Form.Group className="mb-3" controlId="Checked">
            <Form.Check
              className="remember-me"
              label={t("Remember me")}
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
          </Form.Group>
        </Col>
        <Col xs={6}>
          <div
            onClick={() => handleClick("OTP")}
            className="text-end font-13 text-main-color cursor-pointer"
          >
            {t("Forget password")}
          </div>
        </Col>
      </Row>
      <Button aria-label="Aria label" type="submit" className="btn-main w-100 ">
        {t("Login")}
      </Button>

      {msgError !== "" && (
        <Alert variant={"danger"} className="mt-3 py-2">
          {t(msgError)}
        </Alert>
      )}
    </Form>
  );
}

export default FormLogin;
